<template>
  <div class="approveModal">
    <div
      class="contentContainer"
      :class="{ multiMessageContainer: confirmMultiMessage }"
    >
      <div
        class="questionWrap"
        :class="{ multiMessageInformation: confirmMultiMessage }"
      >
        <slot name="text"></slot>
        <slot name="sendingInformation" v-if="confirmMultiMessage"></slot>
      </div>
      <div class="buttonWrap">
        <button-global
          text="NO"
          type="negative"
          @eventPassed="$emit('no')"
        ></button-global>
        <button-global
          text="YES"
          type="positive"
          @eventPassed="$emit('yes')"
        ></button-global>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonGlobal from "./ButtonGlobal";

export default {
  components: {
    ButtonGlobal,
  },
  props: {
    confirmMultiMessage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.$emit("no");
      }
    },
  },
  mounted: function () {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
};
</script>

<style scoped>
@supports (-ms-ime-align: auto) {
  .buttonWrap {
    margin-top: 60px;
  }
  .questionWrap {
    margin-top: 40px;
  }
}

.approveModal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contentContainer {
  background-color: white;
  width: 500px;
  height: 300px;
  border-radius: 5px;
}
.multiMessageContainer {
  width: 600px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.contentContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.questionWrap {
  width: 300px;
}

.buttonWrap {
  display: flex;
  justify-content: center;
}

.multiMessageInformation {
  margin: 20px auto;
  width: 90%;
}
.questionWrap > p {
  color: #707070;
  line-height: 1.5;
  font-size: 20px;
  text-align: center;
}
.questionWrap > p:nth-child(2) {
  margin-top: 50px;
}
</style>
